module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/military-school-lvl2-50.4e954ce2.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/military-school-lvl2-50.png
// module id = 3321
// module chunks = 11